(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('userApplicationService', userApplicationService);

    /* @ngInject */
    function userApplicationService($http, $q, exception, logger, coreService, $odataresource, config, $odata) {
        var service = {
            getModalOptions: getModalOptions,
            getDefaultUserApplication: getDefaultUserApplication,
            getUserApplicationFields: getUserApplicationFields,
            getUserApplications: getUserApplications,
            getUsersByApplication: getUsersByApplication,
            getAdministratorsByApplication: getAdministratorsByApplication,
            saveUserApplication: saveUserApplication,
            saveUserApplicationAdministrator: saveUserApplicationAdministrator,
            deleteUserApplication: deleteUserApplication,
            deleteUserApplicationByUserAndApplication: deleteUserApplicationByUserAndApplication,
            getUserApplicationsByUser: getUserApplicationsByUser,
            getODataResource: getODataResource,
            getTableConfig: getTableConfig
        };

        activate();

        return service;

        function activate() {
        }

        function getODataResource() {
            return $odataresource(config.apiUrl + 'odata/UserApplications',
                    {},
                    {},
                    {
                        odatakey: 'UserApplicationId',
                        isodatav4: true
                    });
        }

        function getDefaultUserApplication() {
            return {
                UserApplicationId: 0,
                IsActive: true,
                LegacyUserId: '',
                isAdministrator: false
            };
        }

        function getTableConfig() {
            return {
                columns: [
                    {
                        id: 'Application',
                        displayName: 'Application Name',
                        ODataKey: 'Application/ApplicationName',
                        type: 'subItem'
                    },
                    {
                        id: 'IsActive',
                        displayName: 'Is Active',
                        ODataKey: 'IsActive',
                        type: 'badge',
                        badge: {
                            on: {
                                className: 'success',
                                display: 'Active'
                            },
                            off: {
                                className: 'danger',
                                display: 'Inactive'
                            }
                        }
                    },
                    {
                        id: 'LegacyUserId',
                        displayName: 'Legacy User ID',
                        ODataKey: 'LegacyUserId',
                        type: 'match'
                    }
                ],
                actions: []
            };
        }

        function getUserApplicationFields(Applications) {
            var Fields = [
                 {
                     key: 'ApplicationId',
                     type: 'select',
                     defaultValue: Applications[0].ApplicationId,
                     ngModelAttrs: {
                         customAttrVal: {
                             attribute: 'disabled'
                         }
                     },
                     templateOptions: {
                         label: 'Applications',
                         options: Applications,
                         disabled: false,
                         valueProp: 'ApplicationId',
                         labelProp: 'ApplicationName',
                         required: true
                     }
                 },
               {
                   key: 'IsActive',
                   type: 'checkbox',
                   defaultValue: true,
                   templateOptions: {
                       label: 'Is Active'
                   }
               },
               {
                   key: 'LegacyUserId',
                   type: 'input',
                   templateOptions: {
                       type: 'text',
                       label: 'Legacy User ID',
                       placeholder: 'Enter Legacy User ID',
                       maxlength: 255
                   }
               }
            ];
            return Fields;
        }

        function postProcessUserApplicationOData(query) {
            return query
                .expand('Application')
                .expand('User')
                .withInlineCount()
                .query()
                .$promise;
        }

        function getUserApplications(tableState) {
            var query = buildUserApplicationQuery(tableState);
            return postProcessUserApplicationOData(query);
        }

        function getUsersByApplication(tableState, tableConfig, applicationID) {
            tableState = tableState || { search: { predicateObject: {} }, sort: {}, pagination: {} };
            tableState.sort = tableState.sort.predicate ? tableState.sort : {
                 predicate: 'User/Email', reverse: false
            };
            var query = buildUserApplicationQuery(tableState, tableConfig);

            return query
                .expand('Application')
                .expand('User')
                .expand('User', 'ConnectionType')
                .expand('User', 'UserRoleTies', 'Role')
                .expand('User', 'UserRoleTies', 'Role', 'Application')
                .filter('Application/ApplicationId', new $odata.Value(parseInt(applicationID).toString(), 'Int32'))
                .withInlineCount()
                .query().$promise;
        }

        function getAdministratorsByApplication(tableState, tableConfig, applicationID) {
            tableState = tableState || { search: { predicateObject: {} }, sort: {}, pagination: {} };
            tableState.sort = tableState.sort.predicate ? tableState.sort : {
                 predicate: 'User/Email', reverse: false
            };
            var query = buildUserApplicationQuery(tableState, tableConfig);

            return query
                .expand('Application')
                .expand('User')
                .expand('User', 'ConnectionType')
                .expand('User', 'UserRoleTies')
                .expand('User', 'UserRoleTies')
                .expand('User', 'UserRoleTies', 'Role')
                .expand('User', 'UserRoleTies', 'Role', 'Application')
                .filter('Application/ApplicationId', new $odata.Value(parseInt(applicationID).toString(), 'Int32'))
                .filter('isAdministrator', new $odata.Value('true', 'Boolean'))
                .withInlineCount()
                .query()
                .$promise;
        }


        function getUserApplicationsByUser(userId, tableState) {
            var query = buildUserApplicationQuery(tableState);
            query.filter('UserId', new $odata.Value(parseInt(userId).toString(), 'Int32'));
            return postProcessUserApplicationOData(query);
        }

        function buildUserApplicationQuery(tableState, tableConfig) {
            var query = service.getODataResource().odata();

            tableConfig = tableConfig || getTableConfig();
            if (!!tableState) {
                coreService.processODataFilters(query, tableState.search.predicateObject, tableConfig.columns);
                coreService.processODataPage(query, tableState.pagination);
            } else {
                tableState = { sort: {} };
            }
            tableState.sort = tableState.sort.predicate ? tableState.sort : {
                predicate: 'Application/ApplicationName', reverse: false
            };
            coreService.processODataSort(query, tableState.sort);
            return query;
        }

        function saveUserApplication(userApplication) {
            return coreService.httpAccountsPost('UserApplication', userApplication);
        }

        function saveUserApplicationAdministrator(userID, userApplication) {
            var query = service.getODataResource().odata();
            return query
                .filter('ApplicationId', new $odata.Value(parseInt(userApplication.ApplicationId).toString(), 'Int32'))
                .filter('UserId', new $odata.Value(parseInt(userApplication.UserId).toString(), 'Int32'))
                .withInlineCount()
            .query()
                .$promise
                .then(function (result) {
                    if (result.count > 0) {
                        userApplication.UserApplicationId = result[0].UserApplicationId;
                    }
                    return coreService.httpAccountsPost('UserApplication/' +
                        userID + '/setAdministrator', userApplication);
                });
        }

        function deleteUserApplication(userApplication) {
            var url = 'UserApplication/';
            url = url + encodeURIComponent(userApplication.UserApplicationId);
            return coreService.httpAccountsPost(url, userApplication);
        }

        function deleteUserApplicationByUserAndApplication(userID, applicationID) {
            var url = 'UserApplication/User/';
            url = url + encodeURIComponent(userID);
            url = url + '/Application/';
            url = url + encodeURIComponent(applicationID);
            return coreService.httpAccountsPost(url);
        }

        function getModalOptions() {
            return {
                animation: true,
                templateUrl: 'app/user/application/dashboard/modal/application.modal.html',
                controllerAs: 'vm'
            };
        }
    }
})();
